<template>
  <nav class="navbar navbar-expand-lg navbar-absolute"
       :class="{'bg-white': showMenu, 'navbar-transparent': !showMenu}">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-toggle d-inline" :class="{toggled: $sidebar.showSidebar}">
          <button type="button"
                  class="navbar-toggler"
                  @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" href="javascript:void(0)"><img src="@/assets/img/CAF_B_BLU.png" style="width:230px"><!--{{ $route.name }}--></a>
      </div>
 
      <button class="navbar-toggler" type="button"
              @click="toggleMenu"
              data-toggle="collapse"
              data-target="#navigation"
              aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
    
      <div class="collapse navbar-collapse show text-left" v-show="showMenu">
        <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
          <drop-down v-if="$route.path == '/dashboard-antiriciclaggio' || $route.path == '/clienti' || $route.path == '/anagrafica-soggetti' || $route.path == '/valutazione' || $route.path == '/valutazione-a' || $route.path == '/prestazioni'" style="margin-top:7px;margin-right:120px"> <!--  -->
            <a href="/#/clienti" data-toggle="dropdown" class="dropdown-toggle nav-link">
              <b style="font-size:16px;">CLIENTI</b>
            </a>
          </drop-down>
          <!-- <drop-down v-if="$route.path == '/dashboard-antiriciclaggio' || $route.path == '/clienti' || $route.path == '/anagrafica-soggetti' || $route.path == '/valutazione' || $route.path == '/prestazioni'" style="margin-top:7px">
            <a href="/#/anagrafica-soggetti" data-toggle="dropdown" class="dropdown-toggle nav-link">
              <strong style="font-size:16px;">ANAGRAFICA SOGGETTI</strong>
            </a>
          </drop-down>
          <drop-down v-if="$route.path == '/dashboard-antiriciclaggio' || $route.path == '/clienti' || $route.path == '/anagrafica-soggetti' || $route.path == '/valutazione' || $route.path == '/prestazioni'" style="margin-top:7px">
            <a href="/#/prestazioni" data-toggle="dropdown" class="dropdown-toggle nav-link">
              <strong style="font-size:16px;">PRESTAZIONI</strong>
            </a>
          </drop-down>
          <drop-down v-if="$route.path == '/dashboard-antiriciclaggio' || $route.path == '/clienti' || $route.path == '/anagrafica-soggetti' || $route.path == '/valutazione' || $route.path == '/prestazioni'" style="margin-top:7px">
            <a href="/#/valutazione" data-toggle="dropdown" class="dropdown-toggle nav-link">
              <strong style="font-size:16px;">VALUTAZIONE</strong>
            </a>
          </drop-down> -->
          
          <!--
          <li class="search-bar input-group"  @click="searchModalVisible = true">
            <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
              <span class="d-lg-none d-md-block">Search</span>
            </button>
          </li>
          <modal :show.sync="searchModalVisible"
                 class="modal-search"
                 id="searchModal"
                 :centered="false"
                 :show-close="true">
            <input slot="header" v-model="searchQuery" type="text" class="form-control" id="inlineFormInputGroup" placeholder="SEARCH">
          </modal>
          drop-down>
            <a href="javascript:void(0)" data-toggle="dropdown" class="dropdown-toggle nav-link">
              <div class="notification d-none d-lg-block d-xl-block"></div>
              <i class="tim-icons icon-sound-wave"></i>
              <p class="d-lg-none text-left">
                Notifications
              </p>
            </a>
            <ul class="dropdown-menu dropdown-menu-right dropdown-navbar">
              <li class="nav-link"><a href="#" class="nav-item dropdown-item">Mike John responded to your email</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">You have 5 more tasks</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Your friend Michael is in town</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Another notification</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Another one</a></li>
            </ul>
          </drop-down>-->
          <!--  <sidebar-link class="dropdown-item" to="/anagrafica-soggetti" name="ANAGRAFICA SOGGETTI"/>
              <sidebar-link class="dropdown-item" to="/valutazione" name="VALUTAZIONE"/>
              <sidebar-link class="dropdown-item" to="/prestazioni" name="PRESTAZIONI"/>-->
              
          <!--<drop-down v-if="$route.path == '/dashboard-antiriciclaggio' || $route.path == '/clienti' || $route.path == '/anagrafica-soggetti' || $route.path == '/valutazione' || $route.path == '/prestazioni'" >
            <a href="javascript:void(0)" data-toggle="dropdown" class="dropdown-toggle nav-link">
              <strong style="font-size:16px;">Antiriciclaggio <i class="fas fa-angle-down"></i></strong>
            </a>
           <li><a href="/#/clienti" class="nav-item dropdown-item">CLIENTI</a></li>
              <li><a href="/#/anagrafica-soggetti" class="nav-item dropdown-item">ANAGRAFICA SOGGETTI</a></li>
              <li><a href="/#/valutazione" class="nav-item dropdown-item">VALUTAZIONE</a></li>
              <li><a href="/#/prestazioni" class="nav-item dropdown-item">PRESTAZIONI</a></li>-->
           <!--<ul class="dropdown-menu dropdown-menu-right dropdown-navbar">-->
             <!-- <li class="nav-link"><a href="#" class="nav-item dropdown-item">Mike John responded to your email</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">You have 5 more tasks</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Your friend Michael is in town</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Another notification</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Another one</a></li>-->
              
         <!--   </ul>
          </drop-down>-->
          <drop-down>
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <div class="photo">
                <img src="@/assets/img/anime3.png" alt="Profile Photo">
              </div>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none">
                Logout
              </p>
            </a>
            <ul class="dropdown-menu dropdown-navbar">
              <!--<li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Profile</a></li>
              <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Settings</a></li>
              <li class="dropdown-divider"></li>-->
              <li class="nav-link"><p class="nav-item dropdown-item">Ciao, {{username}}</p></li>
              <li class="nav-link"><a href="javascript:void(0)"  v-on:click="logout()" class="nav-item dropdown-item">Logout</a></li>
            </ul>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import axios from 'axios'
import DropDown from "@/components/Dropdown.vue";
import Modal from "@/components/Modal.vue";
//import UserServices from "@/services/UserServices.js";

import {
  SidebarPlugin
} from "@/components/index";

  export default{
    components:{
      DropDown,
      Modal,
      SidebarPlugin,
      username: null,
      urlRichieste: 'https://sviluppoallergeni.confcom.it/',//''https://apiintranet.confcom.it/'
    },
    data() {
      return {
        searchModalVisible: false,
        searchQuery: '',
        showMenu: false,
      };
    },
    methods:{
      toggleSidebar(){
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      toggleMenu(){
        this.showMenu  = !this.showMenu;
      },

      logout: async function () {
        //let ris = await logout.UserServices()
        //let token = localStorage.getItem('access_token');
        await axios.delete(
          'https://sviluppoallergeni.confcom.it/logout',
          //'https://sviluppoallergeni.confcom.it/logout',
           {
            withCredentials: true,
            headers: {
              'Content-type': 'application/json',
              //'Authorization': `Bearer ${token}`
            }
          }
        ).then(response => { this.results = response.data})
        //console.log("stampo risposta /logout:")
        //console.log(this.results)
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.setItem('isLogged', false);
        localStorage.removeItem('user_nome');
        localStorage.removeItem('user_cognome');
        localStorage.removeItem('user_tipologia');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_livello');
        localStorage.removeItem('user_id');
        this.$router.push({
          path: '/login'
        })
        //window.location.reload();
      },
       
    },

    beforeMount: function(){
      this.username = localStorage.getItem('user_nome');
      //console.log("noome utente " + this.username)
    },

    computed:{
      isRTL() {
        return this.$rtl.isRTL;
      }
    }
  }
</script>
<style>
</style>
